import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, View, ViewHeader } from '../components/Index';
import { AppPermissions } from '../services/AppPermissions';
import { Appl } from '../Appl';

export const PageNotFoundView: React.FC = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <View id="PageNotFoundView" authKey={AppPermissions.PublicAccess}>
        <ViewHeader title="Page Not Available" />
        <div className="">
          <p className='mb-4'>We're sorry, but you've reached a page that isn't directly accessible.</p>
          <p className='mb-4'>This page is part of a secure application that must be accessed through the MySCERS Member Portal. For your security and privacy, direct access is not allowed.</p>
          <p className='mb-4'>Please return to MySCERS and navigate to this page through the appropriate link.</p>
          <Button title="Return to MySCERS" rounded onClick={() => window.location.href = `${Appl.Setting.MyScersPortalUrl}`} />
          <p className='mt-4'>If you believe you're seeing this message in error or need assistance, please contact SCERS at sacretire@saccounty.gov or call us at (916) 874-9119.</p>
        </div>
      </View>
    </>
  );
};
